import { useAssetStore, useUiStore } from '../../../../../store'
import { GSection, GTooltip } from '../../../../../components/basic-blocks'
import { HelpCircle as RiQuestionLine } from 'components/icons'
import { generateReportTitle } from '../types'
import { ArrowDown as GoArrowDown } from 'components/icons'
import { HelpCircle as AiOutlineQuestionCircle } from 'components/icons'
import { ArrowDown as TbArrowNarrowDown } from 'components/icons'
import { ArrowDown as HiOutlineArrowDown } from 'components/icons'
export const RecentReports = () => {
	const recentReports = useAssetStore((s) => s.recentReports)
	const isLoading = useUiStore((s) => s.isLoading('ASSET_GET_REPORT_REQUESTS'))

	return (
		<GSection containerClassName="w-full !mb-0" loading={isLoading} borderClass="border border-t-border-light rounded-xl">
			<div className="h-[300px]">
				<div className="flex items-center justify-between pb-6">
					<div className="flex gap-x-2 items-center text-lg font-medium">
						Recent reports
						<GTooltip
							position="top"
							arrowClassName="w-0 h-0 absolute bottom-[0.5px] border-l-8 border-l-transparent  border-r-8 border-r-transparent border-t-8 border-t-tooltip-caret"
							contentClassName="border-none mb-2 bg-t-smoke max-w-xs font-medium text-sm text-t-desc-gray"
							content="This shows the recent generated reports">
							<AiOutlineQuestionCircle
								className="text-t-gray-hold w-4 h-4" />
						</GTooltip>
					</div>
				</div>
				{!isLoading && recentReports.length === 0 ? (
					<div className="flex items-center justify-center pt-8">
						<p>No recent reports available you can schedule or download them</p>
					</div>
				) : (
					<div className="flex items-center justify-between">
						<div className="flex flex-col gap-3 w-full pr-8">
							{recentReports.slice(0, 3).map((r) => (
								<div
									key={r.id}
									className="w-full py-3 px-8 border-b flex items-center justify-between"
								>
									<p className='text-t-coupon'>{generateReportTitle(r)}</p>
									<a
										href={r.download_link}
										target="_blank"
										className="flex text-base justify-center border border-t-base-blue gap-x-1 items-center h-[30px] py-3 w-[75px] bg-white rounded-full hover:bg-gray-50 cursor-pointer"
									>
										<HiOutlineArrowDown className="h-4 w-4" />
										<span className="">{r?.format}</span>
									</a>
								</div>
							))}
						</div>
						<div className="flex flex-col gap-3 w-full pl-8 border-t-border border-l">
							{recentReports.slice(3, 6).map((r) => (
								<div
									key={r.id}
									className="w-full py-3 px-8 border-b flex items-center justify-between"
								>
									<p className='text-t-coupon'>{generateReportTitle(r)}</p>
									<a
										href={r.download_link}
										target="_blank"
										className="flex text-base justify-center border border-t-base-blue gap-x-1 items-center h-[30px] py-3 w-[75px] bg-white text-t-default rounded-full hover:bg-gray-50 cursor-pointer"
									>
										<HiOutlineArrowDown className="h-4 w-4" />
										<span className="">{r?.format}</span>
									</a>
								</div>
							))}
						</div>
					</div>
				)}
			</div>
		</GSection>
	)
}
